import { Timestamps } from '@/core/types/shared'
import { Account } from './account.model'

export enum EventType {
  CONSULTATION_INVITATION = 'CONSULTATION_INVITATION',
  EXPERTISE_CREATED = 'EXPERTISE_CREATED',
  EXPERTISE_UPDATED = 'EXPERTISE_UPDATED',
  CONSULTATION_REMINDER = 'CONSULTATION_REMINDER',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_UPDATED = 'ORDER_UPDATED',
  ORDER_REMINDER = 'ORDER_REMINDER',
  EMERGENCY_INVITE = 'EMERGENCY_INVITE',
  FIRST_PASSWORD = 'FIRST_PASSWORD',
  SEND_CONSULTATION_FILES = 'SEND_CONSULTATION_FILES',
  NETWORK_INVITATION_SENT = 'NETWORK_INVITATION_SENT',
  NETWORK_JOIN_REQUEST_ACCEPTED = 'NETWORK_JOIN_REQUEST_ACCEPTED',
  NETWORK_JOIN_REQUEST_DECLINED = 'NETWORK_JOIN_REQUEST_DECLINED',
  NETWORK_CONSULTATION_ORDER = 'NETWORK_CONSULTATION_ORDER',
  NETWORK_EXPERTISE_ORDER = 'NETWORK_EXPERTISE_ORDER',
  NETWORK_ORDER_ACCEPTED = 'NETWORK_ORDER_ACCEPTED',
  NETWORK_DAILY_SUMMARY = 'NETWORK_DAILY_SUMMARY',
}

export enum EventObjectType {
  ADMIN = 'ADMIN',
  CONSULTATION = 'CONSULTATION',
  NETWORK = 'NETWORK',
  ORDER = 'ORDER',
  PATIENT = 'PATIENT',
  ROOM = 'ROOM',
  STAFF = 'STAFF',
  TELEXPERTISE = 'TELEXPERTISE',
}

export enum Priority {
  'HIGH' = 'HIGH',
  'MEDIUM' = 'MEDIUM',
  'LOW' = 'LOW',
}

export enum Channel {
  'SMS' = 'SMS',
  'EMAIL' = 'EMAIL',
  'PUSH' = 'PUSH',
}

export enum RecipientType {
  'PATIENT' = 'PATIENT',
  'STAFF' = 'STAFF',
  'ADMIN' = 'ADMIN',
}

export type Recipient = {
  userId: string
  type: RecipientType
  read: boolean
  seen: boolean
}

export type Event = Timestamps & {
  _id: string
  recipients: Array<Recipient>
  type: EventType
  object_id: string
  object_type: EventObjectType
  priority: Priority
  channels: Array<Channel>
  emails?: string[]
  context?: {
    sender?: Pick<Account, '_id' | 'accountType' | 'userInfo'>
    network?: string
  }
}

